import Hero from "@/features/web/home/heroSection/Hero";
import WhyUse from "@/features/web/home/whyUseSection/WhyUse";
import Classes from "@/features/web/home/classesSection/Classes";
import About from "@/features/web/home/about/About";
import MetaTags from "../../components/MetaTags";

function Home() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة |  تعلم اللغة العربية للثانوية العامة"
                description="صفحة  تعلم اللغة العربية للثانوية العامة على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة.  تعلم اللغة العربية للثانوية العامة لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <Hero />
            <WhyUse />
            <About />
            <Classes />
        </>
    );
}

export default Home;
